import React, { useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | 'contact' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-slate-950 text-slate-500 py-12 border-t border-slate-900" data-id="element-44">
        <div className="container mx-auto px-4 text-center" data-id="element-45">
          <p className="mb-4 font-serif text-slate-400 text-lg" data-id="element-46">
            Pantallas que Roban Infancia
          </p>
          <p className="text-sm mb-8" data-id="element-47">
            &copy; {new Date().getFullYear()} Freidy Salas & Lorena Agostinho.
            Todos los derechos reservados.
          </p>
          <div className="flex justify-center space-x-6 text-xs" data-id="element-48">
            <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors cursor-pointer" data-id="element-49">
              Términos y Condiciones
            </button>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors cursor-pointer" data-id="element-50">
              Política de Privacidad
            </button>
          </div>
          <p className="mt-8 text-xs text-slate-700 max-w-2xl mx-auto" data-id="element-51">
            Descargo de responsabilidad: Los resultados pueden variar. Este
            libro ofrece estrategias educativas y de crianza, no sustituye el
            consejo médico o psicológico profesional.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-52">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-53">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} transition={{
          duration: 0.25
        }} className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-54">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 border-b border-slate-200" data-id="element-55">
                <h2 className="text-xl font-serif font-bold text-slate-900" data-id="element-56">
                  {activeModal === 'privacy' && 'Política de Privacidad'}
                  {activeModal === 'terms' && 'Términos y Condiciones'}
                  {activeModal === 'contact' && 'Información de Contacto'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-100 transition-colors text-slate-500 hover:text-slate-900" data-id="element-57">
                  <X className="w-5 h-5" data-id="element-58" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-slate-700 text-sm leading-relaxed space-y-4" data-id="element-59">
                {activeModal === 'privacy' && <PrivacyContent data-id="element-60" />}
                {activeModal === 'terms' && <TermsContent data-id="element-61" />}
                {activeModal === 'contact' && <ContactContent data-id="element-62" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-slate-500 text-xs" data-id="element-63">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-64">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-65">
        Al adquirir nuestro libro digital, recopilamos la información necesaria
        para procesar tu compra: nombre, dirección de correo electrónico y datos
        de pago. No almacenamos información de tarjetas de crédito directamente;
        los pagos son procesados por plataformas de pago seguras de terceros.
      </p>

      <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-66">
        2. Uso de la Información
      </h3>
      <p data-id="element-67">Utilizamos tu información personal exclusivamente para:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-68">
        <li data-id="element-69">Procesar y entregar tu compra digital</li>
        <li data-id="element-70">Enviarte el enlace de descarga y actualizaciones del producto</li>
        <li data-id="element-71">Responder a tus consultas de soporte</li>
        <li data-id="element-72">
          Enviarte comunicaciones relacionadas con el producto (puedes darte de
          baja en cualquier momento)
        </li>
      </ul>

      <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-73">
        3. Protección de Datos
      </h3>
      <p data-id="element-74">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado, pérdida o
        alteración. Nunca vendemos, alquilamos ni compartimos tu información
        personal con terceros con fines comerciales.
      </p>

      <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-75">4. Cookies</h3>
      <p data-id="element-76">
        Nuestro sitio web puede utilizar cookies para mejorar tu experiencia de
        navegación y analizar el tráfico del sitio. Puedes configurar tu
        navegador para rechazar cookies, aunque esto podría afectar algunas
        funcionalidades.
      </p>

      <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-77">
        5. Tus Derechos
      </h3>
      <p data-id="element-78">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. Para ejercer estos derechos, contáctanos a través
        de los canales indicados en la sección de contacto.
      </p>

      <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-79">
        6. Cambios en esta Política
      </h3>
      <p data-id="element-80">
        Nos reservamos el derecho de actualizar esta política de privacidad.
        Cualquier cambio será publicado en esta página con la fecha de
        actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-slate-500 text-xs" data-id="element-81">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-82">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-83">
        Al adquirir y utilizar el libro digital "Pantallas que Roban Infancia",
        aceptas estos términos y condiciones en su totalidad. Si no estás de
        acuerdo, por favor no realices la compra.
      </p>

      <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-84">
        2. Producto Digital
      </h3>
      <p data-id="element-85">
        Este es un producto digital (libro electrónico) que se entrega mediante
        descarga inmediata tras la confirmación del pago. El contenido incluye
        el libro principal y los anexos imprimibles descritos en la página de
        venta.
      </p>

      <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-86">
        3. Licencia de Uso
      </h3>
      <p data-id="element-87">
        Al comprar este producto, recibes una licencia personal e intransferible
        para:
      </p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-88">
        <li data-id="element-89">Leer y utilizar el contenido para uso personal y familiar</li>
        <li data-id="element-90">Imprimir los anexos para uso doméstico</li>
      </ul>
      <p className="mt-2" data-id="element-91">
        Queda prohibido reproducir, distribuir, revender o compartir el
        contenido total o parcial del libro sin autorización expresa de los
        autores.
      </p>

      <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-92">
        4. Descargo de Responsabilidad
      </h3>
      <p data-id="element-93">
        El contenido de este libro tiene fines educativos e informativos. Las
        estrategias presentadas se basan en investigación sobre neurociencia y
        crianza, pero no sustituyen el consejo médico, psicológico o terapéutico
        profesional. Los resultados pueden variar según cada familia y situación
        particular.
      </p>

      <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-94">
        5. Garantía de Satisfacción
      </h3>
      <p data-id="element-95">
        Ofrecemos una garantía de devolución de 30 días. Si no estás satisfecha
        con el producto, puedes solicitar un reembolso completo dentro de los 30
        días posteriores a la compra, sin preguntas.
      </p>

      <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-96">
        6. Propiedad Intelectual
      </h3>
      <p data-id="element-97">
        Todo el contenido del libro, incluyendo textos, gráficos, metodologías y
        el nombre "Método RECONQUISTA™", son propiedad intelectual de Freidy
        Salas y Lorena Agostinho. Están protegidos por las leyes de derechos de
        autor aplicables.
      </p>
    </>;
}
function ContactContent() {
  return <>
      <p data-id="element-98">
        Si tienes preguntas, necesitas soporte o deseas ejercer tus derechos
        sobre tus datos personales, puedes contactarnos a través de los
        siguientes medios:
      </p>

      <div className="bg-slate-50 rounded-xl p-6 mt-4 space-y-3" data-id="element-99">
        <div data-id="element-100">
          <p className="font-bold text-slate-900" data-id="element-101">Correo Electrónico</p>
          <p className="text-brand-secondary" data-id="element-102">
            contacto@pantallasquerobaninfancia.com
          </p>
        </div>
        <div data-id="element-103">
          <p className="font-bold text-slate-900" data-id="element-104">Autores</p>
          <p data-id="element-105">Freidy Salas & Lorena Agostinho</p>
        </div>
        <div data-id="element-106">
          <p className="font-bold text-slate-900" data-id="element-107">Horario de Atención</p>
          <p data-id="element-108">Lunes a viernes, 9:00 AM - 6:00 PM (hora local)</p>
        </div>
      </div>

      <p className="mt-4" data-id="element-109">
        Nos comprometemos a responder todas las consultas en un plazo máximo de
        48 horas hábiles.
      </p>

      <p className="mt-4 text-slate-500 text-xs" data-id="element-110">
        Para solicitudes de reembolso, por favor incluye tu número de orden y
        correo electrónico de compra.
      </p>
    </>;
}